import { COOKIE_PERIOD } from './const.js'

export function setCookie (name, value, period = COOKIE_PERIOD, path = '/') {
  const validDate = new Date()
  validDate.setTime(validDate.getTime() + period)

  // Encode the Date
  const validString = validDate.toUTCString()
  document.cookie = `${name}=${value};expires=${validString};path=${path}`
}

export function getCookie (name) {
  const cookies = decodeURIComponent(document.cookie)
  const cname = name + '='
  const clist = cookies.split(';')
  // Search for cookie
  for (const cookie of clist) {
    if (cookie.trim().indexOf(cname) === 0) {
      return cookie.trim().substring(cname.length)
    }
  }
  // No cookie found
  return ''
}

export function checkCookie (name) {
  const value = getCookie(name)
  return value !== ''
}

// Some browsers won't delete the cookie if path not specified
export function deleteCookie (name, path) {
  if (checkCookie(name)) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path}`
  }
}

// Check if object is empty
export function isEmpty (obj) {
  return Object.keys(obj).length === 0
}

// Get error message
export function getErrorMessage (err) {
  if (err.response) {
    return err.response.data.message
  } else {
    return err.message
  }
}

// Check if string is valid JSON
export function isJsonString (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}
